import { type ComponentProps } from 'react';

export const MaximizeIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5335_130)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.57143 9.42857H3V3H9.42857V5.57143H5.57143V9.42857ZM3 14.5719H5.57143V18.429H9.42857V21.0005H3V14.5719ZM18.429 18.429H14.5719V21.0005H21.0005V14.5719H18.429V18.429ZM14.5719 5.57143V3H21.0005V9.42857H18.429V5.57143H14.5719Z"
          fill="currentColor"
          style={{ fill: 'currentColor' }}
        />
      </g>
      <defs>
        <clipPath id="clip0_5335_130">
          <rect
            width="18.0005"
            height="18.0005"
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
